<template>
    <div class="footer-item">
        <h4>Sverige</h4>
        <h4>Stora Levene</h4>
        <h4>Levene Skattegården 1</h4>
    </div>
    <div class="footer-item" id="middle-item">
        <h4><a href="https://www.facebook.com/Levene.Impregnering.Forsaljning" target="_blank">Facebook</a></h4>
        <h4><a href="https://www.linkedin.com/company/levene-impregnering-och-f%C3%B6rs%C3%A4ljning" target="_blank">LinkedIn</a></h4>
        <h4><a href="mailto:liof@liof.se">liof@liof.se</a></h4>
    </div>
    <div class="footer-item">
        <h4>ÖPPETTIDER</h4>
        <h4>Måndag-Fredag: TBD</h4>
        <h4>Lördag-Söndag: Stängt</h4>
    </div>

</template>

<script>
    export default {
        name: 'FooterComponent'
    }
</script>
